import React from 'react';
import styled from 'styled-components';

import Input from '../../../components/Input';

function Operator({question, operators, value, onChange}) {
  return (
    <StyledInput
      type="select"
      id={`filter_operator_${question.id}`}
      label={question.text}
      value={value || ''}
      onChange={e => onChange(e.target.value === '' ? null : e.target.value)}>
      <option value="">No filter</option>
      {operators.map(operator => (
        <option key={operator} value={operator}>{operatorMap[operator]}</option>
      ))}
    </StyledInput>
  );
}

const StyledInput = styled(Input)`
  margin-bottom: ${props => !props.value ? 0 : '0.5rem'};
`;

const operatorMap = {
  EQUAL: 'Equals',
  NOT_EQUAL: 'Does not equal',
  CONTAIN: 'Contains',
  NOT_CONTAIN: 'Does not contain',
  GREATER_THAN: 'Greater than',
  GREATER_THAN_OR_EQUAL: 'Greater than or equal',
  LESS_THAN: 'Less than',
  LESS_THAN_OR_EQUAL: 'Less than or equal',
  BETWEEN: 'Between'
};

export default Operator;
